import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminReviews from './AdminReviews';
import AdminReports from './AdminReports';
import AdminLocalNewsGenerator from './AdminLocalNewsGenerator';
import { useAuthStore } from '../store/authStore';

const AdminPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();

  // デバッグ用：現在のユーザー情報をコンソールに出力
  console.log('AdminPage - Current user:', user);

  // 管理者権限チェック
  if (!user || user.role !== 'admin') {
    console.log('AdminPage - Access denied. User role:', user?.role);
    return (
      <Box p={3}>
        <Typography variant="h5" color="error">
          アクセス権限がありません
        </Typography>
        <Typography variant="body1" mt={2}>
          この画面を表示する権限がありません。
        </Typography>
        <Typography variant="body2" mt={1} color="text.secondary">
          現在のユーザー: {user?.email || 'ログインしていません'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ロール: {user?.role || '設定されていません'}
        </Typography>
      </Box>
    );
  }

  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.includes('/admin/users')) return 1;
    if (path.includes('/admin/reviews')) return 2;
    if (path.includes('/admin/reports')) return 3;
    if (path.includes('/admin/local-news')) return 4;
    return 0; // dashboard
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/admin');
        break;
      case 1:
        navigate('/admin/users');
        break;
      case 2:
        navigate('/admin/reviews');
        break;
      case 3:
        navigate('/admin/reports');
        break;
      case 4:
        navigate('/admin/local-news');
        break;
    }
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Typography variant="h4" sx={{ p: 3, pb: 2 }}>
          管理画面
        </Typography>
        <Tabs value={getCurrentTab()} onChange={handleTabChange}>
          <Tab label="ダッシュボード" />
          <Tab label="ユーザー管理" />
          <Tab label="口コミ管理" />
          <Tab label="通報管理" />
          <Tab label="🤖 AI記事生成" />
        </Tabs>
      </Box>

      <Paper sx={{ minHeight: '500px' }}>
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/users" element={<AdminUsers />} />
          <Route path="/reviews" element={<AdminReviews />} />
          <Route path="/reports" element={<AdminReports />} />
          <Route path="/local-news" element={<AdminLocalNewsGenerator />} />
        </Routes>
      </Paper>
    </Box>
  );
};

export default AdminPage;
